import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, CoursesService } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { Course } from '../../../../../models/course';

@Component({
    selector: 'da-teaser-boxes-container',
    templateUrl: './teaser-boxes-container.component.html',
    styleUrls: ['./teaser-boxes-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeaserBoxesContainerComponent implements OnInit {
    @Input() data;
    private _$availableCourses: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>([]);

    constructor(private _coursesService: CoursesService, private _configurationService: ConfigurationService) {}

    public get availableCourses$(): Observable<Course[]> {
        return this._$availableCourses.asObservable();
    }

    ngOnInit() {
        const _hasCategoriesFromConfig = this.data && this.data.cards && this.data.cards.length > 0;
        if (!_hasCategoriesFromConfig && !this._configurationService.hasFeature('DoNotHaveCourses')) {
            this._coursesService.getAllCourses().then((data) => {
                this._$availableCourses.next(data);
            });
        }
    }
}
